import SynthesisREC1 from '../../../page/synthesis/synthesisREC1' //padge
import SynthesisREC2 from '../../../page/synthesis/synthesisREC2' //padge
import AdditionalDocumentREC1 from '../../../page/additionalDocument/additionalDocumentREC1'
import AdditionalDocumentREC2 from '../../../page/additionalDocument/additionalDocumentREC2'
import VerifyDocumentREC1 from '../../../page/verifyDocument/verifyDocumentREC1'
import VerifyDocumentREC2 from '../../../page/verifyDocument/verifyDocumentREC2'
import DefineProjectREC1 from '../../../page/defineProject/defineProjectREC1'
import DefineProjectREC2 from '../../../page/defineProject/defineProjectREC2'
import GenerateCertificateREC1 from '../../../page/generateCertificate/generateCertificateREC1'
import GenerateCertificateREC2 from '../../../page/generateCertificate/generateCertificateREC2'
import DefineSubmittedDateREC1 from '../../../page/defineSubmittedDate/defineSubmittedDateREC1'
import DefineSubmittedDateREC2 from '../../../page/defineSubmittedDate/defineSubmittedDateREC2'
import ReviewerCommentREC1 from '../../../page/reviewerComment/reviewerCommentREC1'
import ReviewerCommentREC2 from '../../../page/reviewerComment/reviewerCommentREC2'

import SynthesisReviewREC1 from '../../../page/synthesisReview/synthesisReviewREC1'
import SynthesisReviewREC2 from '../../../page/synthesisReview/synthesisReviewREC2'

import { OfficerType } from './officerType'
import useAppFolderAndTabStore from '../../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import ResultOfConsiderPrevious from '../../../page/resultOfConsiderPrevious/resultOfConsiderPrevious'

import * as Constants from '../../../../../../constants/constants'
import SignREC2 from '../../../page/sign/signREC2'
import SignRepresentREC2 from '../../../page/signRepresent/signRepresentREC2'
import SignRepresentREC1 from '../../../page/signRepresent/signRepresentREC1'
import SignREC1 from '../../../page/sign/signREC1'
import MemoMessageREC1 from '../../../page/memoMessage/projectAmendment/memoMessageREC1'
import MemoMessageREC2 from '../../../page/memoMessage/projectAmendment/memoMessageREC2'

import SignMemoREC2 from '../../../page/sign/signMemoMessage/signREC2'
import SignMemoREC1 from '../../../page/sign/signMemoMessage/signREC1'
import SignMemoRepresentREC2 from '../../../page/signRepresent/signRepresentMemoMessage/signRepresentREC2'
import SignMemoRepresentREC1 from '../../../page/signRepresent/signRepresentMemoMessage/signRepresentREC1'
import SignVicePresidentREC2 from '../../../page/signVicePresident/signVicePresidentREC2'
import SignVicePresidentREC1 from '../../../page/signVicePresident/signVicePresidentREC1'

import useCheckPermission from '../../../../../../utilities/checkPermission'
import constSubmittedStep from '../../../../../../constants/submittedStep'

const OfficerView: React.FC<OfficerType> = (props) => {
    const { callbackSaveComplete } = props
    const appFolderAndTabStore = useAppFolderAndTabStore()
    const manageProjectStore = useManageProjectStore()
    const checkPermission = useCheckPermission()

    const renderPage = () => {
        const tabID = appFolderAndTabStore?.tabSelected?.id
        const REC = manageProjectStore?.projectData?.irbType
        let isNotDisableTestResult = false
        switch (REC) {
            case 1:
                switch (tabID) {
                    case Constants.menuTab.tab1.id:
                        // tab1 <div> ตรวจสอบเอกสาร REC1</div>
                        if (checkPermission.isUserChairman()) {
                            isNotDisableTestResult =
                                manageProjectStore?.projectData?.stepID === constSubmittedStep.specifyProjectType
                        }
                        return (
                            <VerifyDocumentREC1
                                projectData={manageProjectStore?.projectData ?? undefined}
                                onSaveComplete={callbackSaveComplete}
                                isNotDisableTestResult={isNotDisableTestResult}
                            />
                        )

                    case Constants.menuTab.tab2.id:
                        // code block
                        // return <div> กำหนดประเภทโครงการและกรรมการ REC1</div>
                        return (
                            (manageProjectStore?.projectData && (
                                <DefineProjectREC1
                                    projectData={manageProjectStore?.projectData}
                                    onSaveComplete={callbackSaveComplete}
                                />
                            )) || <></>
                        )
                    case Constants.menuTab.tab3.id:
                        // code block กำหนดชุดโครงการที่ต้องส่ง
                        return <AdditionalDocumentREC1 callbackSaveComplete={callbackSaveComplete} />
                    case Constants.menuTab.tab4.id:
                        // code blockชุดโครงการครบถ้วนและกำหนดส่งความคิดเห็นของผู้ทบทวนหลัก
                        return <DefineSubmittedDateREC1 callbackSaveComplete={callbackSaveComplete} />
                    case Constants.menuTab.tab5.id:
                        // code block บันทึกข้อคิดเห็นของกรรมการ
                        return <ReviewerCommentREC1 callbackSaveComplete={callbackSaveComplete} isOneComment={true} />

                    case Constants.menuTab.tab6.id:
                        // code block สังเคราะห์

                        return <SynthesisREC1 callbackSaveComplete={callbackSaveComplete} isOneComment={true} />
                    case Constants.menuTab.tab7.id:
                        // code block ออกผล
                        return <SynthesisReviewREC1 callbackSaveComplete={callbackSaveComplete} />

                    case Constants.menuTab.tab8.id:
                        // code block ออกใบรับรอง
                        return <GenerateCertificateREC1 callbackSaveComplete={callbackSaveComplete} />

                    case Constants.menuTab.tab9.id:
                        // code block ลงนาม
                        return renderSign(1)

                    case Constants.menuTab.tab10.id:
                        // code block ลงนามแทน
                        return renderSignRepresent(1)
                    case Constants.menuTab.tab11.id:
                        // code block
                        return (
                            <MemoMessageREC1
                                projectData={manageProjectStore?.projectData}
                                onSaveComplete={callbackSaveComplete}
                            />
                        )
                    case Constants.menuTab.tab26.id:
                        return (
                            <ResultOfConsiderPrevious
                                projectID={manageProjectStore?.projectData?.projectID ?? 0}
                                submittedID={
                                    manageProjectStore?.projectData?.aroundSubmittedIDInfo.previousSubmittedID ?? 0
                                }
                            />
                        )
                    default:
                        return <div></div>
                }

            case 2:
                switch (tabID) {
                    case Constants.menuTab.tab1.id:
                        // tab1
                        // return <div> ตรวจสอบเอกสาร REC2</div>
                        if (checkPermission.isUserChairman()) {
                            isNotDisableTestResult =
                                manageProjectStore?.projectData?.stepID === constSubmittedStep.specifyProjectType
                        }
                        return (
                            <VerifyDocumentREC2
                                projectData={manageProjectStore?.projectData ?? undefined}
                                onSaveComplete={callbackSaveComplete}
                                isNotDisableTestResult={isNotDisableTestResult}
                            />
                        )

                    case Constants.menuTab.tab2.id:
                        // code block
                        // return <div> กำหนดประเภทโครงการและกรรมการ REC2</div>
                        return (
                            (manageProjectStore?.projectData && (
                                <DefineProjectREC2
                                    projectData={manageProjectStore?.projectData}
                                    onSaveComplete={callbackSaveComplete}
                                />
                            )) || <></>
                        )
                    case Constants.menuTab.tab3.id:
                        /// code block กำหนดชุดโครงการที่ต้องส่ง
                        return <AdditionalDocumentREC2 callbackSaveComplete={callbackSaveComplete} />
                    case Constants.menuTab.tab4.id:
                        // code blockชุดโครงการครบถ้วนและกำหนดส่งความคิดเห็นของผู้ทบทวนหลัก
                        return <DefineSubmittedDateREC2 callbackSaveComplete={callbackSaveComplete} />
                    case Constants.menuTab.tab5.id:
                        // code block บันทึกข้อคิดเห็นของกรรมการ
                        return <ReviewerCommentREC2 callbackSaveComplete={callbackSaveComplete} isOneComment={true} />

                    case Constants.menuTab.tab6.id:
                        // code block
                        return <SynthesisREC2 callbackSaveComplete={callbackSaveComplete} isOneComment={true} />
                    case Constants.menuTab.tab7.id:
                        // code block
                        return <SynthesisReviewREC2 callbackSaveComplete={callbackSaveComplete} />

                    case Constants.menuTab.tab8.id:
                        // code block
                        return <GenerateCertificateREC2 callbackSaveComplete={callbackSaveComplete} />

                    case Constants.menuTab.tab9.id:
                        // code block
                        return renderSign(2)

                    case Constants.menuTab.tab10.id:
                        // code block
                        return renderSignRepresent(2)
                    case Constants.menuTab.tab11.id:
                        // code block
                        return (
                            <MemoMessageREC2
                                projectData={manageProjectStore?.projectData}
                                onSaveComplete={callbackSaveComplete}
                            />
                        )
                    case Constants.menuTab.tab26.id:
                        return (
                            <ResultOfConsiderPrevious
                                projectID={manageProjectStore?.projectData?.projectID ?? 0}
                                submittedID={
                                    manageProjectStore?.projectData?.aroundSubmittedIDInfo.previousSubmittedID ?? 0
                                }
                            />
                        )
                    default:
                        return <div></div>
                }

            default:
                return <div></div>
        }
    }

    const renderSign = (REC: number) => {
        const isNeedEditForm = manageProjectStore?.projectData?.isNeedEditForm
        //Business** ถ้านักวิจัยมีการแก้ไข from จะทำการออกใบรับรองใหม่แต่ถ้าไม่แก้ไขจะอกเป็นใบบันทึกข้อความ
        if (REC === 1) {
            if (isNeedEditForm) {
                return <SignREC1 callbackSaveComplete={callbackSaveComplete} />
            } else {
                return <SignMemoREC1 callbackSaveComplete={callbackSaveComplete} />
            }
        } else if (REC === 2) {
            if (isNeedEditForm) {
                return <SignREC2 callbackSaveComplete={callbackSaveComplete} />
            } else {
                return <SignMemoREC2 callbackSaveComplete={callbackSaveComplete} />
            }
        }
    }
    const renderSignRepresent = (REC: number) => {
        const isVicePresident = checkPermission.isUserViceChairman()
        let isNeedEditForm = manageProjectStore?.projectData?.isNeedEditForm
        if (
            manageProjectStore?.projectData?.isNeedEditForm === undefined ||
            manageProjectStore?.projectData?.isNeedEditForm === null
        ) {
            isNeedEditForm = true
        }
        //Business** ถ้านักวิจัยมีการแก้ไข from จะทำการออกใบรับรองใหม่แต่ถ้าไม่แก้ไขจะอกเป็นใบบันทึกข้อความ
        if (REC === 1) {
            if (isNeedEditForm) {
                if (isVicePresident) {
                    //Business** กรณีเป็นรองประธานเข้ามาจะแสดงหน้าลงนามสำหรับรองประธาน **//
                    return <SignVicePresidentREC1 callbackSaveComplete={callbackSaveComplete} />
                } else {
                    return <SignRepresentREC1 callbackSaveComplete={callbackSaveComplete} />
                }
            } else {
                return <SignMemoRepresentREC1 callbackSaveComplete={callbackSaveComplete} />
            }
        } else if (REC === 2) {
            if (isNeedEditForm) {
                if (isVicePresident) {
                    //Business** กรณีเป็นรองประธานเข้ามาจะแสดงหน้าลงนามสำหรับรองประธาน **//
                    return <SignVicePresidentREC2 callbackSaveComplete={callbackSaveComplete} />
                } else {
                    return <SignRepresentREC2 callbackSaveComplete={callbackSaveComplete} />
                }
            } else {
                return <SignMemoRepresentREC2 callbackSaveComplete={callbackSaveComplete} />
            }
        }
    }

    return <> {renderPage()} </>
}

const Officer: React.FC<OfficerType> = (props) => {
    return <OfficerView {...props} />
}
export default Officer
